
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top-reviewed/[param]",
      function () {
        return require("private-next-pages/top-reviewed/[param].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top-reviewed/[param]"])
      });
    }
  